<template>
    <div class="login" :style="`min-height: ${windowHeight}px`">
        <div class="login-left">
            <!-- <img class="login-left-bg" src="@/assets/sys/login/signin_bg.png" alt=""> -->
            <img   class="login-left-logo" src="@/assets/sys/login/logo.png" alt="">
            <!-- <div class="login-left-content">
                <div>智能、精准</div>
                <div>重新定义电商营销模式</div>
                <div>全网流量覆盖量级</div>
                <div>
                    <span>20</span>
                    <span>亿</span>
                </div>
            </div> -->
        </div>

        <div class="login-right">
            <div class="login-content">
                <div class="login-content-title">
                    <span>数通一站式电商营销平台</span>
                    <img src="@/assets/sys/login/wap_signin_logo.png" alt="">
                    <div class="login-content-title-text">数通一站式电商营销平台</div>
                </div>

                <div :class="`login-content-input ${usernameError ? 'login-content-input-error' : ''}`">
                    <input v-model="username" maxlength="60" type="text" placeholder="用户名" @input="change($event, 'username')" @focus="focus('username')" @keydown="handleKeydown">
                    <div :class="`login-content-input-mobile-error ${usernameError ? 'login-content-input-mobile-error-show' : ''}`">{{errorText}}</div>
                </div>

                <div :class="`login-content-input ${passwordError ? 'login-content-input-error' : ''}`">
                    <input v-model="password" maxlength="20" :type="passwordType" placeholder="密码" @input="change($event, 'password')" @focus="focus('password')" @keydown="handleKeydown">
                    <div class="login-content-input-visible" @click="handleVisible">
                        <img v-show="!visible" src="@/assets/sys/login/password_invisible.png" alt="">
                        <img v-show="visible" src="@/assets/sys/login/password_visible.png" alt="">
                    </div>
                    <div :class="`login-content-input-mobile-error ${passwordError ? 'login-content-input-mobile-error-show' : ''}`">{{errorText}}</div>
                </div>

                <div class="login-content-bottom" @click="handleLogin">登录</div>

                <div v-if="usernameError || passwordError" class="login-content-error">{{errorText}}</div>

                <!-- <div class="login-bottom">
                    <div class="login-bottom-item">
                        <span>copyright © 2021</span>
                        <span>北京宏宇微科技有限公司</span>
                    </div>
                    <div class="login-bottom-item">
                        <span>京ICP备12005553号</span>
                        <span>京公网安备110114020</span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { validEmail } from '@/utils/reg.js'
import { isEmpty } from '@/utils/common.js'
import { Message } from 'iview'
import router from '@/router';

export default {
    data() {
        return {
            visible: false,
            host: "",
            username: '',
            password: '',
            usernameError: false,
            passwordError: false,
            errorText: '',
            windowHeight: document.body.clientHeight
        }
    },
    computed: {
        passwordType() {
            return this.visible ? 'text' : 'password'
        }
    },
    mounted() {
        this.host = location.host
    },
    beforeRouteEnter(to, from, next) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        if (!isEmpty(userInfo) && userInfo.token && userInfo.customerId) {
            router.push('/overviewData/overviewData')
        } else {
            next()
        }
        next()
    },
    methods: {
        // 点击是否可见图标时触发
        handleVisible() {
            this.visible = !this.visible
        },

        // 处理输入框键盘事件
        handleKeydown(event) {
            if (event.keyCode === 13) {
                this.handleLogin()
            }
        },

        // 输入框获取焦点时触发
        focus(type) {
            this[`${type}Error`] = false
            this.errorText = ""
        },

        // 输入框输入时触发
        change(event, type) {
            this[`${type}Error`] = false
            this[type] = event.target.value
        },

        // 点击登录按钮时触发
        handleLogin() {
            const username = this.username, password = this.password
            if (isEmpty(username)) {
                Message.error('请输入用户名')
                this.usernameError = true
                this.errorText = '请输入用户名'
                return
            }
            if (!validEmail(username)) {
                Message.error('请输入正确的用户名')
                this.usernameError = true
                this.errorText = '请输入正确的用户名'
                return
            }
            if (isEmpty(password)) {
                Message.error('请输入密码')
                this.passwordError = true
                this.errorText = '请输入密码'
                return
            }
            //
            this.$axios({
                url: '/api/syn/rebateDataPlat/user/login',   //'/api/syn/rebateDataPlat/customer/login',
                data: {
                    email: this.username,
                    passwd: window.md5(this.password)
                },
                method: 'POST'
            }).then((res) => {
                localStorage.setItem('userInfo', JSON.stringify(res.Data))
                this.$router.push('/overviewData/overviewData')
            }).catch((err) => {
                this.errorText = err.Msg
            })
        }

    }
}
</script>

<style lang="scss" scoped>
.login {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/sys/login/signin_bg.png);
    background-repeat: no-repeat;
    background-size: cover;
}

.login-left {
    // background-image: linear-gradient(#2884f0, #046ce7);
    .login-left-logo {
        position: absolute;
        left: 18.75%;
        top: 41px;
        width: 182px;
        height: 26px;
    }
}
.login-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .login-content {
        position: absolute;
        top: 0;
        bottom: 100px;
        right: 18.75%;
        width: 440px;
        height: 392px;
        padding: 60px;
        margin: auto 0;
        border-radius: 6px;
        box-shadow: 0px 4px 20px 0px rgba(86,86,86,0.1);
        background-color: #fff;
        .login-content-title {
            margin-bottom: 20px;
            text-align: center;
            > span {
                font-size: 24px;
                line-height: 20px;
                font-weight: 500;
                font-family: "Noto Sans SC";
                color: #434343;
            }
            > img {
                display: none;
            }
            .login-content-title-text {
                display: none;
            }
        }
        .login-content-input {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 63px;
            padding-top: 15px;
            border-bottom: 1px solid #d9d9d9;
            color: #333;
            transition: all 0.15s;
            > input {
                flex: 1;
                border: none;
                outline: none;
                font-size: 14px;
                line-height: 20px;
                font-family: "Noto Sans SC";
            }
            input::-webkit-input-placeholder {
                color: #999;
                font-family: "Noto Sans SC";
            }
            input:-moz-placeholder {
                color: #999;
                font-family: "Noto Sans SC";
            }
            input::-moz-placeholder {
                color: #999;
                font-family: "Noto Sans SC";
            }
            input:-ms-input-placeholder {
                color: #999;
                font-family: "Noto Sans SC";
            }
            .login-content-input-visible {
                position: absolute;
                width: 26px;
                height: 24px;
                padding: 6px;
                right: 4px;
                top: 0;
                bottom: 0;
                margin: auto 0;
                cursor: pointer;
                > img {
                    width: 100%;
                    height: 100%;
                }
            }
            .login-content-input-mobile-error {
                display: none;
            }
        }

        .login-content-input-error {
            border-color: #006cff;
        }
        .login-content-bottom {
            width: 320px;
            height: 56px;
            margin-top: 44px;
            border-radius: 28px;
            font-size: 16px;
            font-family: "Noto Sans SC";
            text-align: center;
            line-height: 56px;
            background-color: #0061e4;
            color: #fff;
            transition: all 0.15s;
            cursor: pointer;
            user-select: none;
        }
        .login-content-bottom:hover {
            background-color: #006dff;
        }
        .login-content-bottom:active {
            background-color: #0054c5;
        }
        .login-content-error {
            position: absolute;
            bottom: -33px;
            left: 0;
            right: 0;
            line-height: 20px;
            text-align: center;
            color: #0061e4;
        }
    }
}

.login-bottom {
    display: none;
}

@media screen and (max-width: 768px) {
    .login {
        background-image: none;
    }
    .login-left {
        display: none;
    }
    .login-right {
        //padding-bottom: 1.32rem;
        .login-content {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 5.8rem;
            height: 7.84rem;
            padding: 0;
            margin: auto;
            box-shadow: none;
            .login-content-title {
                margin-bottom: 1rem;
                > span {
                    display: none;
                }
                > img {
                    display: block;
                    width: 4.16rem;
                    height: 0.6rem;
                    margin: 0 auto;
                }

                .login-content-title-text {
                    display: block;
                    margin-top: 0.16rem;
                    font-size: 0.36rem;
                }
            }
            .login-content-input {
                padding-top: 0.46rem;
                height: 1.32rem;
                > input {
                    font-size: 0.28rem;
                    line-height: 0.28rem;
                }
                .login-content-input-visible {
                    width: 0.6rem;
                    height: 0.5rem;
                    right: 0.08rem;
                    top: auto;
                    bottom: 0.18rem;
                    padding: 0.12rem;
                    > img {
                        display: block;
                        width: 0.36rem;
                        height: 0.26rem;
                    }
                }
                .login-content-input-mobile-error {
                    display: block;
                    position: absolute;
                    left: 0.19rem;
                    bottom: -0.36rem;
                    font-size: 0.24rem;
                    line-height: 0.24rem;
                    color: #ff0344;
                    transform: rotateX(90deg);
                    transform-origin: 50% 0 0;
                    transition: transform 0.15s;
                }
                .login-content-input-mobile-error-show {
                    transform: rotateX(0);
                }
            }
            .login-content-bottom {
                width: 5.8rem;
                height: 1.02rem;
                margin-top: 0.7rem;
                border-radius: 0.51rem;
                font-size: 0.3rem;
                line-height: 1.02rem;
            }
            .login-content-error {
                display: none;
            }
            .login-content-input-error {
                border-color: #ff003c;
            }
        }
    }

    .login-bottom {
        display: block;
        width: 4.8rem;
        margin: 2.14rem auto 0;
        .login-bottom-item {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            > span {
                font-size: 0.24rem;
                line-height: 0.4rem;
                font-family: PingFang SC;
                color: #999;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/sys/login.vue